module.exports = "/_next/static/images/ky-2389d39423fff4f081122c10ea5b5ffb.svg";